
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description'; // for Excel


import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button, Stack } from '@mui/material';

import React, { useEffect, useState } from 'react';
import {
  Typography, Box, TextField, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow,
  Paper, TablePagination, useTheme
} from '@mui/material';
//import axios from 'axios';
import axios from './AxiosInstance';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  // Fetch device data
 /* useEffect(() => {
    const currentUser = sessionStorage.getItem("currentUser");
    const token = sessionStorage.getItem(`token_${currentUser}`);
    
    if (!token) {
      navigate("/");
      return;
    }

    axios.get('http://localhost:5000/api/deviceinfo', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => setDevices(res.data))
    .catch(err => {
      console.error(err);
      if (err.response?.status === 401) {
        navigate("/");
      }
    });
  }, [navigate]);*/


  // Fetch device data
  useEffect(() => {
    let isdidlogout = false;
    const currentUser = sessionStorage.getItem("currentUser");
    const token = sessionStorage.getItem(`token_${currentUser}`);
    console.log("token",token);
    if (!token) {
      console.log('token not found');
     navigate("/");
      return;
    }

    axios.get('/api/deviceinfo', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => setDevices(res.data))
    .catch(err => {
      if(isdidlogout) return;
      const msg = err?.message || err?.response?.data?.message;

  if (msg === 'Token has expired' || msg === 'Invalid token'|| msg === 'Request failed with status code 401') {
    isdidlogout =true;
    console.log(msg);

    alert('⏰ Session expired. Logging you out.');

    const currentUser = sessionStorage.getItem("currentUser");
    sessionStorage.removeItem(`token_${currentUser}`);
    sessionStorage.removeItem("currentUser");

    navigate("/");
  } else {
    alert("⚠️ Something went wrong.");
    console.error(err);
  }
    });

    return ()=> {
      isdidlogout = true;
    } 
  }, [navigate]);


  

  // Filter by search term
  // const filteredDevices = devices.filter(device =>
  //   (device.name || '').toLowerCase().includes(search.toLowerCase())
  // );
  const filteredDevices = Array.isArray(devices)
  ? devices.filter(device =>
      (device.name || '').toLowerCase().includes(search.toLowerCase())
    )
  : []
  // Paginate filtered data
  const paginatedDevices = filteredDevices.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => setPage(newPage);
//downlload pdf file
  const downloadPDF = () => {
    const doc = new jsPDF();
    const tableColumn = ["ID", "Name", "HW Serial", "SIM Number", "IMEI", "FW Version"];
    const tableRows = filteredDevices.map(device => ([
      device.id,
      device.name,
      device.hw_serial,
      device.sim_number,
      device.imei,
      device.fw_version
    ]));
  
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8 }
    });
    
    doc.text("Device Information", 14, 15);
    doc.save('devices.pdf');
  };
  

// Download as Excel
const downloadExcel = () => {
  const worksheet = XLSX.utils.json_to_sheet(filteredDevices);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Devices");
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "devices.xlsx");
};


  
  return (
    <Box p={4} sx={{ bgcolor: theme.palette.background.default, minHeight: '100vh' }}>
      <Typography variant="h5" gutterBottom fontWeight={600}>
        Device Information
      </Typography>

      {/* <TextField
        label="Search by Name"
        variant="outlined"
        fullWidth
        sx={{ mb: 3 }}
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(0);
        }}
      /> */}
      <Stack direction="row" spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
  <TextField
    label="Search by Name"
    variant="outlined"
    fullWidth
    value={search} 
    onChange={(e) => {
      setSearch(e.target.value);
      setPage(0);
    }}
  />
  
  <Button
    variant="contained"
    color="error"
    startIcon={<PictureAsPdfIcon />}
    onClick={downloadPDF}
  >   
  PDF
  </Button>

  <Button
    variant="contained"
    color="success"
    startIcon={<DescriptionIcon />}
    onClick={downloadExcel}
  >
      Excel
  </Button>
</Stack>
        {/* <Stack direction="row" spacing={1} sx={{ mb: 2 , justifyContent: 'flex-end'}}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<PictureAsPdfIcon />}
    onClick={downloadPDF}
  >
   
  </Button>

  <Button
    variant="contained"
    color="success"
    startIcon={<DescriptionIcon />}
    onClick={downloadExcel}
  >
    
  </Button>
</Stack> */}
      <Paper elevation={3}>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>HW Serial</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>SIM Number</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>IMEI</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>FW Version</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedDevices.map((device) => (
                <TableRow key={device.id}>
                  <TableCell>{device.id}</TableCell>
                  <TableCell>{device.name}</TableCell>
                  <TableCell>{device.hw_serial}</TableCell>
                  <TableCell>{device.sim_number}</TableCell>
                  <TableCell>{device.imei}</TableCell>
                  <TableCell>{device.fw_version}</TableCell>
                </TableRow>
              ))}
              {paginatedDevices.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    Waiting for matching devices...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<PictureAsPdfIcon />}
    onClick={downloadPDF}
  >
    Download PDF
  </Button>

  <Button
    variant="contained"
    color="success"
    startIcon={<DescriptionIcon />}
    onClick={downloadExcel}
  >
    Download Excel
  </Button>
</Stack> */}


        <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
          <Typography variant="body2">
            Page {page + 1} of {Math.ceil(filteredDevices.length / rowsPerPage)}
          </Typography>
          <TablePagination
            component="div"
            count={filteredDevices.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[]} // hide dropdown
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Dashboard;
